<template>
  <v-card v-if="typeof cardData != 'undefined'" :flat="flat" class="hoverCard" fill-height style="min-height:320px;max-height:330px;margin:5px;cursor:pointer;">
    <!-- v-if="cardData.engineState.nav"  -->
    <v-card-title style="height:60px;" v-on:click="navTo(cardData.name)" v-on:mouseleave="color='rgb(95,158,239)'" v-on:mouseover="color='rgb(51,82,128)'">
      <div primary class="title" :style="'color:'+color+';'">{{ cardData.name }}</div>
      <v-icon :color="color">play_arrow</v-icon>
      <v-spacer/>
      <div style="font-size:15px;color:rgb(33,33,33);">Last update: {{ cardData.lastUpdate }}</div>
    </v-card-title>
    <!-- <v-card-title v-else style="height:60px;color:rgb(51,82,128);">
        <div primary class="title">{{cardData.name}}</div>
        <v-spacer/>
        <div style="font-size:15px;color:rgb(33,33,33);">Last update: {{cardData.lastUpdate}}</div>
    </v-card-title> -->

    <v-card-actions fill-height style="min-height:260px;">
      <v-container fluid grid-list-md style="padding:5px;height:250px;margin:0px;">
        <v-layout v-if="cardData.twin" row fill-height>
          <v-flex d-flex md3>
            <v-layout column fill-height>
              <v-flex d-flex v-for="item in cardData" :key="item" style="min-height:0px;font-size:13px;padding:0px;">
                <v-layout row v-if="item.label">
                  <v-flex md5 d-flex style="padding-right:0px;">{{ item.label }}:</v-flex>
                  <v-flex md7 v-if="item.value==-1000" d-flex>- {{ item.unit }}</v-flex>
                  <v-flex md7 v-else-if="item.format!=null" d-flex>{{ item.value.toFixed(item.format) }} {{ item.unit }}</v-flex>
                  <v-flex md7 v-else d-flex>{{ item.value }} {{ item.unit }}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md3>
            <v-layout column fill-height>
              <v-flex v-for="eng in engines" :key="eng" md6>
                <v-layout column fill-height>
                  <v-flex md2 d-flex>
                    <div v-if="cardData[eng].engineKPI<0" style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:28px;">{{ eng }} : -</div>
                    <div v-else-if="cardData[eng].engineColor==20" style="color:rgb(205, 57, 64);display:flex;align-items:center;justify-content:center;font-size:28px;">{{ eng }} : {{ cardData[eng].engineKPI }} %</div>
                    <div v-else style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:28px;">{{ eng }} : {{ cardData[eng].engineKPI }} %</div>
                  </v-flex>
                  <v-flex md10 d-flex style="align-items:center;">
                    <div v-if="cardData[eng].engineColor==0" :style="'height:30px; border:none; color:rgb(60, 171, 48); background-color:rgb(60, 171, 48); width:' + cardData[eng].engineKPI+ '%;' "/>
                    <div v-if="cardData[eng].engineColor==10" :style="'height:30px; border:none; color:rgb(255, 184, 29); background-color:rgb(255, 184, 29); width:' + cardData[eng].engineKPI+ '%;' "/>
                    <div v-if="cardData[eng].engineColor==20" :style="'height:30px; border:none; color:rgb(205, 57, 64); background-color:rgb(205, 57, 64); width:' + cardData[eng].engineKPI+ '%;' "/>
                    <div :style="'height:30px; border:none; color:rgb(244,244,244);  background-color:rgb(244,244,244); width:' + (100-cardData[eng].engineKPI)+ '%;' "/>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md3>
            <Trendline v-on:dblclick.native="changeSFOC()" v-bind:trendData="cardData[param]" :twin="true"/>
          </v-flex>
          <v-flex d-flex md3>
            <Trendline v-bind:trendData="cardData['sloc']" :twin="true"/>
          </v-flex>
        </v-layout>
        <v-layout v-else row fill-height>
          <v-flex d-flex md4>
            <v-layout column fill-height>
              <v-flex d-flex v-for="item in cardData" :key="item" style="min-height:0px;font-size:13px;padding:0px;">
                <v-layout row v-if="item.label">
                  <v-flex md5 d-flex style="padding-right:0px;">{{ item.label }}:</v-flex>
                  <v-flex md7 v-if="item.value==-1000" d-flex>- {{ item.unit }}</v-flex>
                  <v-flex md7 v-else-if="item.format!=null" d-flex>{{ item.value.toFixed(item.format) }} {{ item.unit }}</v-flex>
                  <v-flex md7 v-else d-flex>{{ item.value }} {{ item.unit }}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md3>
            <v-layout column fill-height>
              <v-flex md1 d-flex>
                <div v-if="cardData.engineKPI<0" style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:28px;">-</div>
                <div v-else-if="cardData.engineColor==20" style="color:rgb(205, 57, 64);display:flex;align-items:center;justify-content:center;font-size:28px;">{{ cardData.engineKPI }} %</div>
                <div v-else style="color:rgb(117,117,117);display:flex;align-items:center;justify-content:center;font-size:28px;">{{ cardData.engineKPI }} %</div>
              </v-flex>
              <v-flex md10 d-flex style="align-items:center;">
                <div v-if="cardData.engineColor==0" :style="'height:30px; border:none; color:rgb(60, 171, 48); background-color:rgb(60, 171, 48); width:' + cardData.engineKPI+ '%;' "/>
                <div v-if="cardData.engineColor==10" :style="'height:30px; border:none; color:rgb(255, 184, 29); background-color:rgb(255, 184, 29); width:' + cardData.engineKPI+ '%;' "/>
                <div v-if="cardData.engineColor==20" :style="'height:30px; border:none; color:rgb(205, 57, 64); background-color:rgb(205, 57, 64); width:' + cardData.engineKPI+ '%;' "/>
                <div :style="'height:30px; border:none; color:rgb(244,244,244);  background-color:rgb(244,244,244); width:' + (100-cardData.engineKPI)+ '%;' "/>
              </v-flex>
              <v-flex md1 d-flex style="align-items:center;justify-content:center;font-size:16px;">Engine KPI</v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md3>
            <Trendline v-on:dblclick.native="changeSFOC()" v-bind:trendData="cardData[param]"/>
          </v-flex>
          <v-flex d-flex md3>
            <Trendline v-bind:trendData="cardData['sloc']"/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>

import Trendline from './Trendline'
import {globalStore} from "../main.js"

export default {
  name: "DashboardCard",
  components: {
    Trendline
  },
  props: {
    cardData: Object,
    flat: Boolean
  },
  data: function () {
    return {
      keys: ['LAT', 'LON', 'ME_Power_perc', 'ensp', 'STW', 'engineState', 'version'],
      color: 'rgb(95,158,239)',
      param: 'bsfc',
      engines: ['Port', 'Stbd']
    }
  },
  methods: {
    navTo(vesselName) {
      this.$router.push({path: `/vessel-view/${vesselName}`});
    },
    changeSFOC() {
      if (this.param == 'bsfc')
        this.param = 'fcon';
      else
        this.param = 'bsfc';
    }
  },
  mounted() {
  },
  watch: {
    cardData: function () {
    }
  }
}
</script>

<style scoped>
.hoverCard:hover {
  border-style: solid;
  border-width: 1px;
  border-color: rgb(219, 219, 219);
}

/* .hoverTitle
{
    color:rgb(51,82,128);
}
.hoverTitle:hover
{
    color:rgb(95,158,239);
} */
</style>


